import * as React from "react";
const SvgButtonStatistics = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 140 140",
	...props
}, /* @__PURE__ */ React.createElement("g", {
	fill: "none",
	stroke: "#000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}, /* @__PURE__ */ React.createElement("path", {
	d: "M4.375 4.375v131.25h131.25",
	strokeWidth: 8.749995
}), /* @__PURE__ */ React.createElement("path", {
	d: "M84.583 53.958H4.375V24.792h80.208a4.492 4.492 0 0 1 4.492 4.491v20.184a4.492 4.492 0 0 1-4.492 4.491ZM61.25 83.125H4.375V53.958H61.25a4.492 4.492 0 0 1 4.492 4.492v20.183a4.492 4.492 0 0 1-4.492 4.492Z",
	strokeWidth: 8.749995
}), /* @__PURE__ */ React.createElement("path", {
	d: "M113.633 112.292H4.375V83.125h109.258a4.433 4.433 0 0 1 4.492 4.492V107.8a4.433 4.433 0 0 1-4.492 4.492Z",
	strokeWidth: 8.749995
})));
export { SvgButtonStatistics as ReactComponent };
